import { CustomTourInquiry, CustomTourInquiryFormData } from '../types';
import { appConfig } from '../config/appConfig';

const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:4000/api';

const getAdminToken = (): string => {
  return btoa(`${appConfig.admin.username}:${appConfig.admin.password}`);
};

export const submitCustomTourInquiry = async (
  formData: CustomTourInquiryFormData
): Promise<CustomTourInquiry> => {
  const response = await fetch('/api/custom-tour-inquiries', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Authentication failed. Please check admin credentials.');
    }
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || errorData.message || `HTTP ${response.status}: ${response.statusText}`);
  }

  return response.json();
};

export const fetchCustomTourInquiries = async (): Promise<CustomTourInquiry[]> => {
  const response = await fetch(`${API_BASE_URL}/custom-tour-inquiries`, {
    headers: {
      Authorization: `Bearer ${getAdminToken()}`,
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Authentication failed. Please check admin credentials.');
    }
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
  }

  const data = await response.json();
  return data.items || [];
};
